export const filteredFlightsActions={
    FILTERUPDATE:"FILTERUPDATE",
    UPDATESORTOPTIONS:"UPDATESORTOPTIONS",
    UPDATECOUNTSORTUPDATE : "UPDATECOUNTSORTUPDATE"
}